import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'styles';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';

import api from 'services';
import MapComponent from './Map';
import constants from 'constants';

class MergingPorts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            sourceObject: {
                name: '',
            },
            sourceItems: [],

            destinationObject: {
                name: '',
            },
            destinationItems: [],

        };

        this.onUpdateInput = this.onUpdateInput.bind(this);
        this.onChooseAutoComplete = this.onChooseAutoComplete.bind(this);
        this.merge = this.merge.bind(this);
    }

    merge() {
        this.props.mergePorts();
    }

    updateInputSource(searchText) {
        const sourceObject = { name: searchText };

        this.setState({
            sourceObject,
        }, () => {
            this.props.addValue('sourcePort', {});

            if (searchText.length <= 1) {
                return;
            }

            api.findPortAdmin({ name: searchText, withAreasWithChild: true })
                .then((response) => {
                    const sourceItems = [];

                    if (response.status === 200) {
                        response.data.data.forEach((item) => {
                            sourceItems.push({
                                name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                                item: (<MenuItem
                                    style={{ width: '100%' }}
                                    primaryText={`${item.name} ${item.country ? `(${item.country.name})` : ''}`}
                                    item={item}
                                />),
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach((alternativeName) => {
                                    sourceItems.push({
                                        name: `${alternativeName} (alternative name)`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${alternativeName} (alternative name)`}
                                            item={item}
                                        />),
                                    });
                                });
                            }

                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach((subPort) => {
                                    sourceItems.push({
                                        name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                            item={subPort}
                                        />),
                                    });
                                });
                            }
                        });

                        this.setState({
                            sourceItems,
                        }, () => {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
        });
    }

    updateInputDestination(searchText) {
        const destinationObject = { name: searchText };

        this.setState({
            destinationObject,
        }, () => {
            this.props.addValue('destinationPort', {});

            if (searchText.length <= 1) {
                return;
            }

            api.findPortAdmin({ name: searchText })
                .then((response) => {
                    const destinationItems = [];

                    if (response.status === 200) {
                        response.data.data.forEach((item) => {
                            destinationItems.push({
                                name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                                item: (<MenuItem
                                    style={{ width: '100%' }}
                                    primaryText={`${item.name} ${item.country ? `(${item.country.name})` : ''}`}
                                    item={item}
                                />),
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach((alternativeName) => {
                                    destinationItems.push({
                                        name: `${alternativeName} (alternative name)`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${alternativeName} (alternative name)`}
                                            item={item}
                                        />),
                                    });
                                });
                            }

                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach((subPort) => {
                                    destinationItems.push({
                                        name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                            item={subPort}
                                        />),
                                    });
                                });
                            }
                        });

                        this.setState({
                            destinationItems,
                        }, () => {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
        });
    }

    onUpdateInput(searchText, type) {
        switch (type) {
        case 'source':
            this.updateInputSource(searchText);
            break;
        case 'destination':
            this.updateInputDestination(searchText);
            break;
        }
    }

    onChooseSource(updateProperties) {
        if (typeof updateProperties === 'string' && this.state.sourceItems.length > 0) {
            let { sourceObject } = this.state;
            sourceObject = this.state.sourceItems[0].item.props.item;

            this.setState({
                sourceObject,
                sourceItems: [],
            }, () => {
                this.props.addValue('sourcePort', sourceObject);
            });

            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        // let { sourceObject } = this.state;
        // sourceObject = updateProperties.item.props.item;

        this.setState({
            sourceObject: updateProperties.item.props.item,
            sourceItems: [],
        }, () => {
            this.props.addValue('sourcePort', updateProperties.item.props.item);
        });
    }

    onChooseDestination(updateProperties) {
        if (typeof updateProperties === 'string' && this.state.destinationItems.length > 0) {
            let { destinationObject } = this.state;
            destinationObject = this.state.destinationItems[0].item.props.item;

            this.setState({
                destinationObject,
                destinationItems: [],
            }, () => {
                this.props.addValue('destinationPort', destinationObject);
            });

            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        // let { destinationObject } = this.state;
        // destinationObject = updateProperties.item.props.item;

        this.setState({
            destinationObject: updateProperties.item.props.item,
            destinationItems: [],
        }, () => {
            this.props.addValue('destinationPort', updateProperties.item.props.item);
        });
    }

    onChooseAutoComplete(updateProperties, type) {
        console.log('updateProperties', updateProperties);

        switch (type) {
        case 'source':
            this.onChooseSource(updateProperties);
            break;
        case 'destination':
            this.onChooseDestination(updateProperties);
            break;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.clearPorts) {
            return this.setState({
                sourceObject: {
                    name: '',
                },
                sourceItems: [],

                destinationObject: {
                    name: '',
                },
                destinationItems: [],
            });
        }

        this.setState({
            sourceObject: nextProps.sourcePort,
        });
    }

    render() {
        const {
            sourceObject,
            sourceItems,
            destinationObject,
            destinationItems,
        } = this.state;

        const { disabledBtn } = this.props;

        return (
            <div>
                <div className="row">
                    <h3 className='col-xs-3'>
                        Port or area to port
                    </h3>
                </div>
                <div className="row">
                    <div className='col-xs-4'>
                        <p style={{ fontSize: '12px' }}>
                            Auto Complete area and ports (Search fields are name, alt name). <br />
                        </p>
                        <AutoComplete
                            textFieldStyle={styles.autoCompleteCSS}
                            floatingLabelText='Source'
                            searchText={sourceObject.name}
                            dataSource={sourceItems}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={(searchText) => { this.onUpdateInput(searchText, 'source'); }}
                            onNewRequest={(chosenRequest) => { this.onChooseAutoComplete(chosenRequest, 'source'); }}
                            filter={AutoComplete.noFilter}
                            style={{ width: '100%' }}
                            listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                            fullWidth
                            popoverProps={{
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' },
                            }}
                        />
                    </div>
                    <div className='col-xs-4'>
                        <p style={{ fontSize: '12px' }}>
                            Auto Complete only ports (Search fields are name, alt name). <br />
                        </p>
                        <AutoComplete
                            textFieldStyle={styles.autoCompleteCSS}
                            floatingLabelText='Destination'
                            searchText={destinationObject.name}
                            dataSource={destinationItems}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={(searchText) => { this.onUpdateInput(searchText, 'destination'); }}
                            onNewRequest={(chosenRequest) => { this.onChooseAutoComplete(chosenRequest, 'destination'); }}
                            filter={AutoComplete.noFilter}
                            style={{ width: '100%' }}
                            listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                            fullWidth
                            popoverProps={{
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' },
                            }}
                        />
                    </div>
                    <div className='col-xs-4'>
                        <RaisedButton
                            primary
                            disabled={disabledBtn}
                            label='merge ports'
                            onClick={this.merge}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        {
                            sourceObject.country ?
                                !sourceObject.coordinates ? null : <MapComponent
                                    coordinates={sourceObject.coordinates}
                                    type='ports'
                                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                    loadingElement={<div style={{ height: '100%' }} />}
                                    containerElement={<div style={{ height: '300px' }} />}
                                    mapElement={<div style={{ height: '100%' }} />}
                                />
                                :
                                !sourceObject.childs || sourceObject.childs.length === 0 ? null : <MapComponent
                                    coordinates={sourceObject.childs}
                                    type="area"
                                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                    loadingElement={<div style={{ height: '100%' }} />}
                                    containerElement={<div style={{ height: '300px' }} />}
                                    mapElement={<div style={{ height: '100%' }} />}
                                    areaPolygon={sourceObject.areaCoordinates}
                                />
                        }
                        {
                            sourceObject.childs && sourceObject.childs.length === 0 ?
                                'Area doesn`t has ports'
                                :
                                ''
                        }

                    </div>
                    <div className="col-xs-4">
                        {
                            !destinationObject.coordinates ? null : <MapComponent
                                coordinates={destinationObject.coordinates}
                                type="ports"
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                loadingElement={<div style={{ height: '100%' }} />}
                                containerElement={<div style={{ height: '300px' }} />}
                                mapElement={<div style={{ height: '100%' }} />}
                                areaPolygon={sourceObject.areaCoordinates}
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, {
        mergePorts, addValue, disabledBtn, clearPorts, 
    }) => ({
        mergePorts,
        addValue,
        disabledBtn,
        clearPorts,
    }),
    dispatch => bindActionCreators(
        {
        },
        dispatch,
    ),
)(MergingPorts);



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Ports.jsx